/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2021-06-08 09:24:33
 * @LastEditTime: 2022-09-19 18:07:19
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import moment from 'moment';
import api from './api';
import './plugins/antd';
import './plugins/element';
import './plugins/components';
import store from './store/'
import qs from 'qs';
import regular from './plugins/regular'
import utils from '@/plugins/utils'
import Filter from '@/plugins/filter';
import EventBus from './plugins/eventBus'
import Md5 from 'js-md5';
import BaiduMap from 'vue-baidu-map'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import { FormModel } from 'ant-design-vue';
Vue.use(FormModel);

Vue.use(VueDirectiveImagePreviewer)
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$moment = moment;
Vue.prototype.$qs = qs;
Vue.prototype.$api = api;
Vue.prototype.$regular = regular;
Vue.prototype.$utils = utils;
Vue.prototype.$domain = baseConfig.vue_base_url;
Vue.prototype.$md5 = Md5;
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'd4apEA9WF7vLjkt1fOzD2sWCj5SBPkUa'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 
